/**
 * <facet-bar-engine> — facet-bar pilotée par le moteur Meilisearch.
 *
 * Réutilise le markup/CSS de la facet-bar (facet-bar.css) et le contrat DOM
 * du chrome `facet-bar-search.liquid`, mais alimente tout depuis
 * window.jaiioSearch (getState/getFacets/setFilter/toggleFilter/setPrice/setSort/clear
 * + event 'change'). Autonome : ne dépend pas de facet-bar.js (mode natif).
 *
 * Apparence + comportement = ceux de la facet-bar native ; seule la source de
 * données change (moteur au lieu de collection.filters).
 */
(function () {
  "use strict";

  var CAT_LEVELS = ["univers", "categorie", "sous_categorie", "sous_sous_categorie"];

  // Libellés : ce fichier ne sait pas lire `locales/fr.json`, c'est
  // `snippets/jaiio-search-config.liquid` qui les injecte dans config.text.facets.
  var T_ROOT = (window.jaiioSearchConfig || {}).text || {};
  var T = T_ROOT.facets || {};
  var T_LABEL = T.label || {};
  var T_SORT = T.sort || {};
  var COLLECTION_SORT = (window.jaiioSearchConfig || {}).page_type === "collection";
  // Remplace les jetons %nom% des traductions à paramètre (voir jaiio-search-config).
  function fill(template, values) {
    return String(template == null ? "" : template).replace(/%(\w+)%/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match;
    });
  }

  // Icônes inline (le JS ne peut pas rendre les snippets 'icon' du thème).
  var CHECK_ICON = window.JaiioFacetsUI.CHECK_ICON;
  // Coche du tri, à droite du choix actif (maquette `.smenu .it .tick`).
  var TICK_ICON = '<svg class="icon" viewBox="0 0 12 12" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m2 6.5 2.8 2.8L10 3.5"/></svg>';
  // Chevron « descendre d'un niveau » de l'arbre Catégories (maquette `.dr`).
  var CHEVRON_RIGHT_ICON = '<svg viewBox="0 0 12 12" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="m4.5 3 3 3-3 3"/></svg>';

  // Facettes « simples » (hors prix, catégories, taille/pointure gérés à part).
  var FACETS = [
    { key: "marque", type: "list", searchable: true },
    { key: "couleur", type: "swatch" },
    { key: "etat", type: "list" },
    { key: "matiere", type: "list", searchable: true },
    { key: "model", type: "list", searchable: true },
    { key: "tags", type: "list" },
    { key: "prix_doux", type: "single", labels: { "10": "-10 %", "20": "-20 %", "30": "-30 %" } },
  ];

  var CONDITION_ORDER = [
    "jamais porte avec etiquette",
    "jamais porte",
    "tres bon etat",
    "bon etat",
    "etat correct",
  ];
  var MATERIAL_SEARCH_THRESHOLD = 12;

  var SORTS = [
    { v: COLLECTION_SORT ? "-created" : "-date", l: T_SORT.newest },
    { v: COLLECTION_SORT ? "created" : "date", l: T_SORT.oldest },
    { v: "price", l: T_SORT.price_asc },
    { v: "-price", l: T_SORT.price_desc },
  ];

  // Map FR → hex intégrée (identique à snippets/color-swatch-style.liquid).
  var DEFAULT_COLORS = (function () {
    var raw = "noir:#1c1c1c,blanc:#ffffff,blanc cassé:#f3efe7,blanc casse:#f3efe7,gris:#9e9e9e,gris clair:#d3d3d3,gris foncé:#5b5b5b,gris fonce:#5b5b5b,anthracite:#2f3133,argent:#c4c4c4,argenté:#c4c4c4,argente:#c4c4c4,beige:#d8c4a0,sable:#e2d3b3,écru:#efe7d6,ecru:#efe7d6,crème:#f3ead3,creme:#f3ead3,ivoire:#fbf7e9,nude:#e3bc9a,taupe:#8b8178,marron:#6b4423,chocolat:#5a3a22,café:#6f4e37,cafe:#6f4e37,camel:#c19a6b,cognac:#9a5b3b,caramel:#b07a3f,bordeaux:#6d1f2c,bourgogne:#6d1f2c,brique:#a3412c,rouge:#c0392b,rose:#e8a0bf,rose pâle:#f4c8d2,rose pale:#f4c8d2,rose poudré:#e7bfc0,rose poudre:#e7bfc0,vieux rose:#c98a9b,fuchsia:#d6308c,framboise:#c2185b,corail:#ff7f50,saumon:#fa8072,orange:#e67e22,abricot:#f4a460,pêche:#ffdab9,peche:#ffdab9,jaune:#f4d03f,moutarde:#cf9f17,doré:#d4af37,dore:#d4af37,or:#d4af37,vert:#3a9d5d,vert clair:#a8d5a2,vert foncé:#1e5631,vert fonce:#1e5631,vert kaki:#78866b,kaki:#78866b,menthe:#98e2c6,olive:#808000,sapin:#1e5631,émeraude:#2ecc71,emeraude:#2ecc71,turquoise:#1abc9c,bleu:#2e6cc4,bleu clair:#a3c9e8,bleu ciel:#87ceeb,bleu marine:#1f2a44,marine:#1f2a44,bleu roi:#2440a8,bleu canard:#1c6b75,canard:#1c6b75,denim:#3b5b86,indigo:#3f3b8c,cobalt:#1d4ed8,violet:#8e44ad,mauve:#b07aa1,lavande:#b497d6,parme:#cbb9d8,lilas:#c8a2c8,prune:#6a2e4d,aubergine:#4b2238,transparent:#f0f0f0";
    var map = {};
    raw.split(",").forEach(function (item) {
      var i = item.indexOf(":");
      if (i !== -1) map[item.slice(0, i).toLowerCase().trim()] = item.slice(i + 1).trim();
    });
    return map;
  })();

  // Style de pastille couleur — même ordre de résolution que color-swatch-style.liquid.
  function swatchStyle(label) {
    var lower = String(label).toLowerCase().trim();
    var cfg = (window.jaiioSearchConfig && window.jaiioSearchConfig.swatch_config) || [];
    for (var i = 0; i < cfg.length; i++) {
      var parts = String(cfg[i]).split(":");
      if (parts.length < 2 || parts[0].toLowerCase().trim() !== lower) continue;
      var val = parts.slice(1).join(":").trim();
      if (val.indexOf("#") !== -1) return "background-color: " + val;
      var base = ((window.jaiioSearchConfig && window.jaiioSearchConfig.swatch_file_sample) || "").split("multicolors_72x72.png")[0];
      var dot = val.lastIndexOf(".");
      if (base && dot !== -1) return "background-image: url(" + base + val.slice(0, dot) + "_72x72" + val.slice(dot) + ")";
      break;
    }
    if (/multicolor|imprim|motif|multico/.test(lower)) {
      return "background: conic-gradient(from 90deg, #e74c3c, #f1c40f, #2ecc71, #3498db, #9b59b6, #e74c3c)";
    }
    if (DEFAULT_COLORS[lower]) return "background-color: " + DEFAULT_COLORS[lower];
    return "background-color: " + lower;
  }

  function esc(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }
  function normalize(value) {
    return String(value || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
  }
  function toNumber(value) {
    if (value == null || value === "") return null;
    var n = parseFloat(value);
    return isNaN(n) ? null : n;
  }
  function api() { return window.jaiioSearch; }
  // Mécanique d'interface partagée avec <facet-bar> (assets/jaiio-facets-ui.js)
  var UI = window.JaiioFacetsUI;

  var SIZE_ORDER = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL", "4XL"];

  // Ordre d'affichage des valeurs : pointures croissantes, tailles du XXS au 4XL,
  // états du meilleur au moins bon ; les autres facettes gardent l'ordre du moteur.
  function sortValues(key, values) {
    if (key === "pointure") {
      values.sort(function (a, b) {
        var na = toNumber(a.label), nb = toNumber(b.label);
        if (na == null && nb == null) return 0;
        if (na == null) return 1; if (nb == null) return -1;
        return na - nb;
      });
    } else if (key === "taille") {
      values.sort(function (a, b) {
        var ia = SIZE_ORDER.indexOf(String(a.label).toUpperCase());
        var ib = SIZE_ORDER.indexOf(String(b.label).toUpperCase());
        if (ia === -1 && ib === -1) return 0;
        if (ia === -1) return 1; if (ib === -1) return -1;
        return ia - ib;
      });
    } else if (key === "etat") {
      values.sort(function (a, b) {
        var ia = CONDITION_ORDER.indexOf(normalize(a.label));
        var ib = CONDITION_ORDER.indexOf(normalize(b.label));
        if (ia === -1 && ib === -1) return normalize(a.label).localeCompare(normalize(b.label), "fr");
        if (ia === -1) return 1;
        if (ib === -1) return -1;
        return ia - ib;
      });
    }
  }

  class FacetBarEngine extends HTMLElement {
    connectedCallback() {
      this._searchTerms = {};   // texte tapé dans une recherche de facette
      this._catPath = [];       // [{ key, value, label }] fil d'Ariane catégories
      this._openPanelId = null;
      this._openTrigger = null;
      this._openSheetEl = null;
      this._drilldownId = null;
      this._panelRevision = 0;
      this._renderedPanels = Object.create(null);

      this.addEventListener("click", this._onClick.bind(this));
      this.addEventListener("change", this._onChange.bind(this));
      this.addEventListener("input", this._onInput.bind(this));
      this.addEventListener("keydown", this._onKeydown.bind(this));

      this._onDocClick = function (event) {
        if (!this._openPanelId || this._isMobile()) return;
        if (this.contains(event.target)) return;
        this.closePanel();
      }.bind(this);
      // Au scroll, le panneau desktop reste ouvert et suit sa pill (barre collante).
      this._onScroll = function () { UI.followPanel(this); }.bind(this);
      document.addEventListener("click", this._onDocClick, true);
      window.addEventListener("scroll", this._onScroll, { passive: true });

      this._boot();
    }

    disconnectedCallback() {
      document.removeEventListener("click", this._onDocClick, true);
      window.removeEventListener("scroll", this._onScroll);
    }

    _isMobile() { return UI.isMobile(); }

    // Attend que jaiio-search.js ait posé window.jaiioSearch, puis s'abonne.
    _boot() {
      if (!api() || !api().on) {
        return void setTimeout(this._boot.bind(this), 50);
      }
      api().on("change", this.render.bind(this));
      this.render();
      UI.resumePendingSizes(this, this._selectedSizes.bind(this));
    }

    /* ───────────────────────── Rendu (depuis le moteur) ───────────────────────── */

    render() {
      if (!api() || !api().getState) return;
      var state = api().getState();
      var facets = api().getFacets();
      this._state = state;
      this._facets = facets;
      this._panelRevision++;

      var focusMark = this._captureFocus();
      // Garder le référentiel des tailles même si son panneau n'a jamais été
      // ouvert : la bascule du profil doit encore connaître les choix proposés.
      this._updateSizeValues("taille", state, facets);
      this._updateSizeValues("pointure", state, facets);
      // Les distributions restent en mémoire. Les centaines d'options des
      // panneaux fermés ne sont créées qu'à l'ouverture, avec la dernière réponse.
      if (this._openPanelId) this._renderPanel(this._openPanelId);
      if (this._drilldownId) this._renderPanel(this._drilldownId);
      this._renderSort(state);
      this._renderChips(state);
      this._renderPillCounts(state);
      this._renderSheetRows(state, facets);
      UI.renderMySizes(this, this._selectedSizes(state));
      this._updateResultLabels(state.total);
      this._restoreFocus(focusMark);
    }

    _renderPanel(panelId) {
      if (this._renderedPanels[panelId] === this._panelRevision) return;
      var state = this._state;
      var facets = this._facets;
      if (!state) return;
      if (panelId === "facet-panel-mataille") {
        this._renderSizeGroup("taille", state);
        this._renderSizeGroup("pointure", state);
        UI.renderMySizes(this, this._selectedSizes(state));
      } else if (panelId === "facet-panel-categories") {
        this._renderCategories(state, facets);
      } else if (panelId === "facet-panel-prix") {
        this._renderPrice(state);
      } else {
        var facet = FACETS.find(function (item) { return panelId === "facet-panel-" + item.key; });
        if (!facet) return;
        this._renderFacetValues(facet, state, facets);
      }
      this._renderedPanels[panelId] = this._panelRevision;
    }

    // Appelé avant le placement et le focus, en panneau desktop comme en
    // drill-down mobile : mêmes options et même premier contrôle dès l'ouverture.
    _onPanelOpen(panelId) { this._renderPanel(panelId); }

    /* ── Focus et rendu ──
       Chaque changement d'état réécrit les listes d'options : l'élément focalisé
       disparaît, et au clavier la tabulation repart du haut du document. On note
       l'option focalisée (facette + valeur) avant le rendu pour la retrouver après. */

    _captureFocus() {
      var el = document.activeElement;
      if (!el || !this.contains(el) || !el.getAttribute) return null;
      var key = el.getAttribute("data-jaiio-filter");
      return key ? { key: key, value: el.value } : null;
    }

    _restoreFocus(mark) {
      if (!mark) return;
      var nodes = this.querySelectorAll("[data-jaiio-filter]");
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].getAttribute("data-jaiio-filter") === mark.key && nodes[i].value === mark.value) {
          return nodes[i].focus({ preventScroll: true });
        }
      }
      // L'option a disparu (compteur à zéro) : rester au moins dans le panneau ouvert.
      var open = this._drilldownId || this._openPanelId;
      if (open) {
        var panel = document.getElementById(open);
        if (panel) UI.focusFirst(panel, "container");
      }
    }

    /* ── Ma taille ── */

    _selectedSizes(state) {
      var filters = (state || api().getState()).filters;
      return { taille: (filters.taille || []).slice(), pointure: (filters.pointure || []).slice() };
    }

    // La bascule ne coche que des tailles que la page propose : une taille absente
    // ajouterait un filtre sans pièce (cf. _renderSizeGroup pour la liste proposée).
    _toggleMataille() {
      var next = UI.toggledSizes(this, this._selectedSizes(), this._sizeLabels);
      api().setFilters({ taille: next.taille, pointure: next.pointure });
    }

    // Groupes proposés par la page (voir offeredSizes) : ceux dont le moteur a
    // déjà renvoyé des valeurs.
    _sizesOffered() {
      var seen = this._sizeSeen || {};
      return { taille: !!(seen.taille && seen.taille.length), pointure: !!(seen.pointure && seen.pointure.length) };
    }

    _saveMataille() {
      UI.saveMySizes(this, this._selectedSizes(), this._selectedSizes.bind(this));
    }

    // Liste triée [{ label, count }] pour une facette (valeurs sélectionnées gardées visibles).
    _facetValues(key, state, facets) {
      var dist = (facets && facets[key]) || {};
      var isVisible = api()._core.isFacetValueVisible;
      var values = Object.keys(dist).filter(function (label) {
        return isVisible(key, label) || (state.filters[key] || []).indexOf(label) !== -1;
      })
        .map(function (label) { return { label: label, count: dist[label] }; });
      (state.filters[key] || []).forEach(function (selected) {
        if (!values.some(function (v) { return v.label === selected; })) {
          values.push({ label: selected, count: 0 });
        }
      });
      sortValues(key, values);
      return values;
    }

    _optionHtml(facet, value, checked) {
      var key = facet.key;
      var display = facet.labels ? (facet.labels[value.label] || value.label) : value.label;
      var disabled = value.count === 0 && !checked;
      var id = "fbe-" + key + "-" + String(value.label).replace(/[^a-zA-Z0-9]/g, "-");
      if (facet.type === "swatch") {
        var white = String(value.label).toLowerCase().trim() === "blanc" ? " facet-swatch--white" : "";
        return '<div class="facet-swatch facet-swatch--color' + white + (disabled ? " is-disabled" : "") + '">' +
          '<input class="facet-swatch__radio visually-hidden facet-input" type="checkbox" id="' + id + '" value="' + esc(value.label) + '" data-jaiio-filter="' + key + '"' + (checked ? " checked" : "") + '>' +
          '<label class="facet-swatch__item color-swatch__item" for="' + id + '" style="' + swatchStyle(value.label) + '"><span class="visually-hidden">' + esc(value.label) + "</span></label>" +
          '<span class="facet-swatch__name">' + esc(value.label) + "</span>" +
          '<span class="facet-swatch__count">' + value.count + "</span></div>";
      }
      if (facet.type === "box") {
        return '<div class="facet-swatch facet-swatch--block' + (disabled ? " is-disabled" : "") + '">' +
          '<input class="facet-swatch__radio visually-hidden facet-input" type="checkbox" id="' + id + '" value="' + esc(value.label) + '" data-jaiio-filter="' + key + '"' + (checked ? " checked" : "") + '>' +
          '<label class="facet-swatch__item facet-swatch__item--block" for="' + id + '">' + esc(display) +
          (value.count == null ? "" : '<small class="facet-swatch__n">' + value.count + "</small>") + "</label></div>";
      }
      // list / single (checkbox)
      return '<label class="facet-check" data-search-text="' + esc(normalize(value.label)) + '">' +
        '<input class="facet-check__input facet-input" type="checkbox" value="' + esc(value.label) + '" data-jaiio-filter="' + key + '"' +
        (facet.type === "single" ? " data-jaiio-single" : "") + (checked ? " checked" : "") + ">" +
        '<span class="facet-check__box" aria-hidden="true">' + CHECK_ICON + "</span>" +
        '<span class="facet-check__label">' + esc(display) + "</span>" +
        '<span class="facet-check__count">' + value.count + "</span></label>";
    }

    _renderFacetValues(facet, state, facets) {
      var container = this.querySelector('[data-jaiio-values="' + facet.key + '"]');
      if (!container) return;
      var values = this._facetValues(facet.key, state, facets);
      var selected = state.filters[facet.key] || [];
      var listClass = facet.type === "swatch" ? "facet-swatch-list facet-swatch-list--color"
        : facet.type === "box" ? "facet-swatch-list facet-swatch-list--block"
        : "facet-check-list";
      var panel = container.closest("[data-panel]");
      var searchWrap = panel && panel.querySelector('[data-facet-search-wrap="' + facet.key + '"]');
      var searchEnabled = facet.key === "marque" || facet.key === "model" ||
        (facet.key === "matiere" && values.length > MATERIAL_SEARCH_THRESHOLD);
      if (searchWrap) searchWrap.hidden = !searchEnabled;
      if (!searchEnabled) {
        this._searchTerms[facet.key] = "";
        var searchInput = searchWrap && searchWrap.querySelector("[data-facet-search]");
        if (searchInput) searchInput.value = "";
      }
      var term = this._searchTerms[facet.key] || "";
      var html = values.map(function (v) {
        return this._optionHtml(facet, v, selected.indexOf(v.label) !== -1);
      }, this).join("");
      container.className = "facet-panel__values " + listClass;
      container.innerHTML = html;
      var empty = panel && panel.querySelector("[data-facet-empty]");
      if (empty && facet.searchable) empty.hidden = html !== "" || term === "" || !searchEnabled;
      // Ne pas retirer les options hors recherche du DOM : effacer la saisie
      // doit les réafficher aussi après une nouvelle réponse du moteur.
      var input = searchWrap && searchWrap.querySelector("[data-facet-search]");
      if (searchEnabled && input && term) this._refreshSearchList(input);
    }

    /*
     * Taille et pointure se combinent en OU côté moteur (« L + 41 » remonte les
     * vêtements en L et les chaussures en 41), mais le moteur calcule la
     * distribution d'un groupe sous le filtre de l'autre : dès qu'une taille est
     * cochée, il ne renvoie plus aucune pointure (et inversement). Le groupe
     * garderait alors ses seules valeurs cochées, voire disparaîtrait. Dans ce
     * cas on reprend les valeurs déjà vues sur la page — à défaut, le référentiel
     * `taille_reference` — sans compteur, puisque le moteur n'en donne pas.
     */
    _updateSizeValues(key, state, facets) {
      var other = key === "taille" ? "pointure" : "taille";
      var trusted = !(state.filters[other] || []).length;
      var values = this._facetValues(key, state, facets);
      var selected = state.filters[key] || [];
      this._sizeSeen = this._sizeSeen || {};
      this._sizeLabels = this._sizeLabels || {};

      var dist = Object.keys((facets && facets[key]) || {});
      // Une distribution non vide est toujours une vraie valeur de la page.
      if (trusted || dist.length) {
        this._sizeSeen[key] = dist;
      } else {
        var block = this.querySelector("[data-mataille-block]");
        var known = this._sizeSeen[key] ||
          UI.parseSizes(block && block.getAttribute(key === "taille" ? "data-ref-tailles" : "data-ref-pointures"));
        values = selected.concat(known.filter(function (label) {
          return selected.indexOf(label) === -1;
        })).map(function (label) { return { label: label, count: null }; });
        sortValues(key, values);
      }

      this._sizeLabels[key] = values.map(function (v) { return v.label; });
      this._sizeOptions = this._sizeOptions || {};
      this._sizeOptions[key] = values;
    }

    _renderSizeGroup(key, state) {
      var container = this.querySelector('[data-jaiio-values="' + key + '"]');
      if (!container) return;
      var facet = { key: key, type: "box" };
      var selected = state.filters[key] || [];
      var values = this._sizeOptions[key] || [];
      var group = container.closest(".facet-mataille-group");
      if (group) group.hidden = values.length === 0;
      container.className = "facet-swatch-list facet-swatch-list--block";
      container.innerHTML = values.map(function (v) {
        return this._optionHtml(facet, v, selected.indexOf(v.label) !== -1);
      }, this).join("");
    }

    /* ── Prix ── */

    _renderPrice(state) {
      var container = this.querySelector('[data-jaiio-values="prix"]');
      if (!container) return;
      var bounds = state.priceBounds;
      if (!bounds || bounds.max == null || bounds.max <= 0) { container.innerHTML = ""; return; }
      var rangeMax = Math.max(1, Math.ceil(bounds.max));
      var prix = state.prix || {};
      var curMin = prix.min != null ? prix.min : 0;
      var curMax = prix.max != null ? prix.max : rangeMax;
      var pMin = (curMin / rangeMax) * 100;
      var pMax = (curMax / rangeMax) * 100;
      var cur = (window.jaiioSearchConfig && window.jaiioSearchConfig.currency_symbol) || "€";
      container.className = "facet-panel__values";
      // Ordre de la maquette (`.prng`) : Min / Max, la jauge, puis les fourchettes.
      // Même DOM que `snippets/facet-bar-options.liquid` (moteur natif).
      container.innerHTML =
        '<facet-price class="facet-price" data-range-max="' + rangeMax + '">' +
        '<div class="facet-price__inputs">' +
        '<label class="facet-price__input"><span class="facet-price__lbl">' + esc(T.price_min_short) + "</span>" +
        '<input type="number" inputmode="numeric" class="facet-price__field facet-input" data-price-field="min" min="0" max="' + rangeMax + '" placeholder="0" aria-label="' + esc(T.price_min) + '"' + (prix.min != null ? ' value="' + Math.floor(curMin) + '"' : "") + ">" +
        '<i class="facet-price__cur">' + esc(cur) + "</i></label>" +
        '<span class="facet-price__sep" aria-hidden="true">—</span>' +
        '<label class="facet-price__input"><span class="facet-price__lbl">' + esc(T.price_max_short) + "</span>" +
        '<input type="number" inputmode="numeric" class="facet-price__field facet-input" data-price-field="max" min="0" max="' + rangeMax + '" placeholder="' + rangeMax + '" aria-label="' + esc(T.price_max) + '"' + (prix.max != null ? ' value="' + Math.ceil(curMax) + '"' : "") + ">" +
        '<i class="facet-price__cur">' + esc(cur) + "</i></label>" +
        "</div>" +
        '<div class="facet-price__slider range-group" style="--range-min: ' + pMin + "%; --range-max: " + pMax + '%;">' +
        '<input type="range" class="facet-price__range range" data-range="min" min="0" max="' + rangeMax + '" value="' + Math.floor(curMin) + '" aria-label="' + esc(T.price_min) + '" aria-valuetext="' + Math.floor(curMin) + ' ' + esc(cur) + '">' +
        '<input type="range" class="facet-price__range range" data-range="max" min="0" max="' + rangeMax + '" value="' + Math.ceil(curMax) + '" aria-label="' + esc(T.price_max) + '" aria-valuetext="' + Math.ceil(curMax) + ' ' + esc(cur) + '">' +
        "</div>" +
        '<p class="facet-panel__section-label">' + esc(T.price_presets) + "</p>" +
        '<div class="facet-price__presets" data-price-presets>' +
        UI.pricePresetsHtml(rangeMax, prix.min != null ? prix.min : null, prix.max != null ? prix.max : null) +
        "</div></facet-price>";
    }

    // Slider bougé → maj remplissage + champs (visuel seulement).
    _priceFill(fp) {
      var rangeMax = Number(fp.getAttribute("data-range-max")) || 1;
      var ranges = fp.querySelectorAll("[data-range]");
      var group = fp.querySelector(".facet-price__slider");
      if (ranges.length < 2 || !group) return;
      var vMin = Number(ranges[0].value), vMax = Number(ranges[1].value);
      if (vMin > vMax) { var t = vMin; vMin = vMax; vMax = t; }
      group.style.setProperty("--range-min", (vMin / rangeMax) * 100 + "%");
      group.style.setProperty("--range-max", (vMax / rangeMax) * 100 + "%");
      var minField = fp.querySelector('[data-price-field="min"]'), maxField = fp.querySelector('[data-price-field="max"]');
      if (minField) minField.value = vMin > 0 ? Math.floor(vMin) : "";
      if (maxField) maxField.value = vMax < rangeMax ? Math.ceil(vMax) : "";
      ranges[0].setAttribute("aria-valuetext", Math.floor(vMin) + " €");
      ranges[1].setAttribute("aria-valuetext", Math.ceil(vMax) + " €");
    }

    // Champs modifiés → maj sliders + remplissage.
    _syncRangesFromFields(fp) {
      var rangeMax = Number(fp.getAttribute("data-range-max")) || 1;
      var minField = fp.querySelector('[data-price-field="min"]'), maxField = fp.querySelector('[data-price-field="max"]');
      var ranges = fp.querySelectorAll("[data-range]");
      var vMin = toNumber(minField && minField.value); if (vMin == null) vMin = 0;
      var vMax = toNumber(maxField && maxField.value); if (vMax == null) vMax = rangeMax;
      if (ranges[0]) ranges[0].value = vMin;
      if (ranges[1]) ranges[1].value = vMax;
      this._priceFill(fp);
    }

    _commitPrice(fp) {
      var rangeMax = Number(fp.getAttribute("data-range-max")) || 1;
      var minField = fp.querySelector('[data-price-field="min"]'), maxField = fp.querySelector('[data-price-field="max"]');
      var min = toNumber(minField && minField.value), max = toNumber(maxField && maxField.value);
      api().setPrice(min != null && min > 0 ? min : null, max != null && max < rangeMax ? max : null);
    }

    /* ── Catégories (arbre drill-down piloté par les 4 facettes) ── */

    _renderCategories(state, facets) {
      var body = this.querySelector('[data-cat-body]');
      if (!body) return;
      var depth = this._catPath.length;
      var levelKey = CAT_LEVELS[depth];
      var title = this.querySelector('[data-cat-title]');
      var back = this.querySelector('#facet-panel-categories [data-action="cat-back"]');
      if (title) title.textContent = depth ? this._catPath[depth - 1].label : T.categories;
      if (back) back.hidden = !(depth > 0 || this._isMobile());
      if (!levelKey) { body.innerHTML = ""; return; }

      var values = this._facetValues(levelKey, state, facets);
      var selected = state.filters[levelKey] || [];
      var hasDeeper = depth < CAT_LEVELS.length - 1;
      var total = state.total == null ? "" : state.total;

      // « Toutes les pièces » : sélectionnée quand aucune valeur du niveau courant n'est cochée.
      var html = '<button type="button" class="facet-cat-row facet-cat-row--all' + (selected.length === 0 ? " is-selected" : "") + '" data-cat-all>' +
        '<span class="facet-cat-check" aria-hidden="true">' + CHECK_ICON + "</span>" +
        '<span class="facet-cat-row__label">' + esc(T.all_pieces) + "</span>" +
        '<span class="facet-cat-row__count">' + total + "</span></button>";

      html += values.map(function (v) {
        var on = selected.indexOf(v.label) !== -1;
        return '<div class="facet-cat-row' + (on ? " is-selected" : "") + '" data-cat-key="' + levelKey + '" data-cat-value="' + esc(v.label) + '" data-cat-label="' + esc(v.label) + '">' +
          '<button type="button" class="facet-cat-select" data-cat-toggle aria-pressed="' + on + '">' +
          '<span class="facet-cat-check" aria-hidden="true">' + CHECK_ICON + "</span>" +
          '<span class="facet-cat-row__label">' + esc(v.label) + "</span>" +
          '<span class="facet-cat-row__count">' + v.count + "</span></button>" +
          (hasDeeper ? '<button type="button" class="facet-cat-drill" data-cat-drill aria-label="' + esc(fill(T.explore, { value: v.label })) + '">' + CHEVRON_RIGHT_ICON + "</button>" : "") +
          "</div>";
      }).join("");
      body.innerHTML = html;
    }

    /* ── Tri ── */

    _sortOptions(state) {
      var opts = SORTS.slice();
      if (COLLECTION_SORT && (state.sort === "-date" || state.sort === "date")) {
        opts.unshift({ v: state.sort, l: state.sort === "-date" ? T_SORT.published_newest : T_SORT.published_oldest });
      }
      if (state.q) opts.unshift({ v: "r", l: T_SORT.relevance });
      return opts;
    }

    _renderSort(state) {
      var opts = this._sortOptions(state);
      // Sans tri explicite, c'est le premier qui s'applique : il est coché, comme
      // le libellé de la barre l'annonce déjà.
      var active = (opts.filter(function (o) { return o.v === state.sort; })[0] || opts[0] || {});
      // Un nom de groupe par liste : le panneau desktop et la feuille mobile
      // portent chacun leurs radios, et sous un même nom le navigateur n'en
      // laissait qu'un coché — celui de la feuille, rendue en second.
      var html = function (name) {
        return opts.map(function (o) {
          return '<label class="facet-choice">' +
            '<input type="radio" name="' + name + '" value="' + o.v + '" data-jaiio-sort' + (o === active ? " checked" : "") + ">" +
            '<span class="facet-choice__label">' + esc(o.l) + "</span>" +
            '<span class="facet-choice__check" aria-hidden="true">' + TICK_ICON + "</span></label>";
        }).join("");
      };
      var current = active.l || "";
      [["[data-jaiio-sort-choices]", "jaiio_sort"], ["[data-jaiio-sort-choices-mobile]", "jaiio_sort_mobile"]].forEach(function (pair) {
        var el = this.querySelector(pair[0]);
        if (el) el.innerHTML = '<div class="facet-choice-list">' + html(pair[1]) + "</div>";
      }, this);
      this.querySelectorAll("[data-sort-label]").forEach(function (el) { el.textContent = current; });
    }

    /* ── Chips (filtres actifs) ── */

    _chipEntries(state) {
      var entries = [];
      var self = this;
      CAT_LEVELS.concat(["marque", "couleur", "etat", "matiere", "model", "tags", "taille", "pointure"]).forEach(function (key) {
        (state.filters[key] || []).forEach(function (value) {
          entries.push({ key: key, value: value, label: value });
        });
      });
      (state.filters.prix_doux || []).forEach(function (value) {
        entries.push({ key: "prix_doux", value: value, label: "-" + value + " %" });
      });
      if (state.prix) {
        entries.push({ key: "prix", value: "", label: (state.prix.min != null ? state.prix.min : "") + "–" + (state.prix.max != null ? state.prix.max : "") + " €" });
      }
      return entries;
    }

    _renderChips(state) {
      var entries = this._chipEntries(state);
      var html = entries.map(function (c) {
        return '<span class="facet-chip">' +
          '<span class="facet-chip__label">' + esc(c.label) + "</span>" +
          '<button type="button" class="facet-chip__remove" data-action="remove-chip" data-chip-key="' + c.key + '" data-chip-value="' + esc(c.value) + '" aria-label="Retirer">&times;</button>' +
          "</span>";
      }).join("");
      ["[data-chips-list]", "[data-chips-list-mobile]"].forEach(function (sel) {
        var el = this.querySelector(sel);
        if (el) el.innerHTML = html;
      }, this);
      this.querySelectorAll("[data-chips], [data-chips-mobile]").forEach(function (el) {
        el.hidden = entries.length === 0;
      });
    }

    /* ── Compteurs (pills + résultats) ── */

    _renderPillCounts(state) {
      var self = this;
      function count(keys) {
        return keys.reduce(function (n, k) { return n + (state.filters[k] || []).length; }, 0);
      }
      var counts = {
        mataille: count(["taille", "pointure"]),
        categories: count(CAT_LEVELS),
        marque: count(["marque"]), couleur: count(["couleur"]), etat: count(["etat"]),
        matiere: count(["matiere"]), model: count(["model"]), tags: count(["tags"]),
        prix_doux: count(["prix_doux"]),
        prix: state.prix ? 1 : 0,
      };
      this.querySelectorAll("[data-jaiio-pill-count]").forEach(function (el) {
        var key = el.getAttribute("data-jaiio-pill-count");
        var n = key === "more" ? (counts.matiere + counts.model + counts.tags + counts.prix_doux) : (counts[key] || 0);
        el.textContent = n;
        el.hidden = n === 0;
        var pill = el.closest(".facet-pill");
        if (pill) pill.classList.toggle("is-active", n > 0);
      });
      var total = this._chipEntries(state).length;
      this.querySelectorAll("[data-mobile-count]").forEach(function (el) {
        el.textContent = total; el.hidden = total === 0;
      });
    }

    _updateResultLabels(total) {
      this.querySelectorAll("[data-results-label]").forEach(function (el) {
        el.textContent = total == null ? "" : total;
      });
      UI.updateCollectionCount(total, this._hasActiveFilters());
    }

    // Des filtres actifs ? Le prix compte, les clés de facettes aussi ; la
    // disponibilité forcée, non — elle n'est pas un choix de la visiteuse.
    _hasActiveFilters() {
      var state = this._state || {};
      var filters = state.filters || {};
      var prix = state.prix || {};
      if (prix.min != null || prix.max != null) return true;
      return Object.keys(filters).some(function (k) {
        return (filters[k] || []).length > 0;
      });
    }

    /* ── Bottom-sheet mobile : lignes drill-down ── */

    // Niveau 1 de la feuille : une ligne par facette, avec sa valeur courante —
    // les libellés choisis, comme sur la barre native, et non un décompte. Les
    // facettes fusionnées (Catégories, Ma taille) restent en « N sélections » :
    // un chemin de catégories tient rarement sur une ligne.
    _renderSheetRows(state, facets) {
      var rows = this.querySelector("[data-sheet-rows]");
      if (!rows) return;
      var self = this;
      // Chevron vers la droite : la ligne ouvre un écran, elle ne déplie pas.
      var chevron = ((window.jaiioSearchConfig || {}).icons || {}).chevron_right || "";

      function row(controls, label, value, isSet) {
        return '<button type="button" class="facet-sheet-row" data-action="open-drilldown" aria-controls="' + controls + '">' +
          '<span class="facet-sheet-row__label">' + esc(label) + "</span>" +
          '<span class="facet-sheet-row__value' + (isSet ? " is-set" : "") + '" data-row-value>' + esc(value) + "</span>" +
          chevron + "</button>";
      }
      function count(n) {
        var form = T.selected_count || {};
        return fill(n > 1 ? form.other : form.one, { count: n });
      }

      var html = "";
      if (this.querySelector("#facet-panel-categories")) {
        var nCat = CAT_LEVELS.reduce(function (n, k) { return n + (state.filters[k] || []).length; }, 0);
        html += row("facet-panel-categories", T.categories, nCat > 0 ? count(nCat) : T.all_categories, nCat > 0);
      }
      if (this.querySelector("#facet-panel-mataille")) {
        var nSize = (state.filters.taille || []).length + (state.filters.pointure || []).length;
        html += row("facet-panel-mataille", T.my_size, nSize > 0 ? count(nSize) : T.all_sizes, nSize > 0);
      }
      FACETS.forEach(function (facet) {
        if (!self.querySelector("#facet-panel-" + facet.key)) return;
        var pill = self.querySelector('[data-jaiio-facet="' + facet.key + '"] .facet-pill__label');
        var label = pill ? pill.textContent.trim() : facet.key;
        var selected = state.filters[facet.key] || [];
        html += row("facet-panel-" + facet.key, label, selected.length ? selected.join(", ") : T.all_categories, selected.length > 0);
      });
      if (this.querySelector("#facet-panel-prix")) {
        var prix = state.prix || {};
        var set = prix.min != null || prix.max != null;
        html += row("facet-panel-prix", T.label && T.label.prix, set ? self._priceSummary(prix) : T.all_categories, set);
      }
      rows.innerHTML = html;
    }

    // Résumé d'une plage de prix pour la ligne de la feuille, dans les mêmes
    // termes que les tranches du panneau.
    _priceSummary(prix) {
      var cur = (window.jaiioSearchConfig || {}).currency_symbol || "€";
      if (prix.min == null) return fill(T.price_under, { amount: Math.ceil(prix.max) + " " + cur });
      if (prix.max == null) return fill(T.price_over, { amount: Math.floor(prix.min) + " " + cur });
      return fill(T.price_between, { from: String(Math.floor(prix.min)), to: Math.ceil(prix.max) + " " + cur });
    }

    /* ───────────────────────── Événements ───────────────────────── */

    _onChange(event) {
      var target = event.target;
      if (target.hasAttribute && target.hasAttribute("data-jaiio-filter")) {
        var key = target.getAttribute("data-jaiio-filter");
        if (target.hasAttribute("data-jaiio-single")) {
          api().setFilter(key, target.checked ? [target.value] : []);
        } else {
          api().toggleFilter(key, target.value);
        }
        return;
      }
      if (target.hasAttribute && target.hasAttribute("data-jaiio-sort")) {
        api().setSort(target.value);
        if (this._openSheetEl) this.closeSheet(); else if (this._isMobile()) this.closeDrilldown(); else this.closePanel();
        return;
      }
      if (target.hasAttribute && target.hasAttribute("data-range")) {
        var fpr = target.closest("facet-price");
        if (fpr) this._commitPrice(fpr);
        return;
      }
      if (target.hasAttribute && target.hasAttribute("data-price-field")) {
        var fp = target.closest("facet-price");
        if (fp) { this._syncRangesFromFields(fp); this._commitPrice(fp); }
      }
    }

    _onInput(event) {
      var target = event.target;
      if (target.hasAttribute("data-facet-search")) {
        this._searchTerms[target.getAttribute("data-facet-search")] = target.value;
        this._refreshSearchList(target);
        return;
      }
      if (target.hasAttribute("data-range")) {
        var fp = target.closest("facet-price");
        if (fp) this._priceFill(fp);
      }
    }

    _onKeydown(event) {
      if (event.key === "Enter" && event.target.hasAttribute && event.target.hasAttribute("data-facet-search")) {
        event.preventDefault();
        return;
      }
      if (event.key === "Escape") UI.closeTopLayer(this);
    }

    // Filtre la liste d'une facette searchable sans re-fetch (juste masquage).
    _refreshSearchList(input) {
      var key = input.getAttribute("data-facet-search");
      var container = this.querySelector('[data-jaiio-values="' + key + '"]');
      if (!container) return;
      var term = normalize(input.value.trim());
      var visible = 0;
      container.querySelectorAll(".facet-check[data-search-text]").forEach(function (item) {
        var match = !term || item.getAttribute("data-search-text").indexOf(term) !== -1;
        item.hidden = !match;
        if (match) visible++;
      });
      var panel = container.closest("[data-panel]");
      var empty = panel && panel.querySelector("[data-facet-empty]");
      if (empty) empty.hidden = visible !== 0;
    }

    _onClick(event) {
      var self = this;
      // Catégories : « Toutes les pièces » / sélection / drill / retour
      var catAll = event.target.closest("[data-cat-all]");
      if (catAll && this.contains(catAll)) {
        event.preventDefault();
        var allLevelKey = CAT_LEVELS[this._catPath.length];
        if (allLevelKey) api().clear(allLevelKey);
        return;
      }
      var catToggle = event.target.closest("[data-cat-toggle]");
      if (catToggle && this.contains(catToggle)) {
        event.preventDefault();
        var row = catToggle.closest(".facet-cat-row");
        return api().toggleFilter(row.getAttribute("data-cat-key"), row.getAttribute("data-cat-value"));
      }
      var catDrill = event.target.closest("[data-cat-drill]");
      if (catDrill && this.contains(catDrill)) {
        event.preventDefault();
        var drillRow = catDrill.closest(".facet-cat-row");
        this._catPath.push({ key: drillRow.getAttribute("data-cat-key"), value: drillRow.getAttribute("data-cat-value"), label: drillRow.getAttribute("data-cat-label") });
        api().setFilter(drillRow.getAttribute("data-cat-key"), [drillRow.getAttribute("data-cat-value")]);
        return this._renderCategories(api().getState(), api().getFacets());
      }

      // Tranches de prix, cochables à plusieurs : le filtre ne porte qu'une
      // plage, on applique donc celle qui contient toutes les tranches cochées.
      var preset = event.target.closest(".facet-price__preset");
      if (preset && this.contains(preset)) {
        event.preventDefault();
        var presets = preset.closest("[data-price-presets]");
        var fp = preset.closest("facet-price");
        var rangeMax = fp ? Number(fp.getAttribute("data-range-max")) || 0 : 0;
        var hull = UI.togglePricePreset(presets, preset, rangeMax);
        return api().setPrice(hull && hull.min > 0 ? hull.min : null, hull ? hull.max : null);
      }

      var actionEl = event.target.closest("[data-action]");
      if (!actionEl || !this.contains(actionEl)) return;
      var action = actionEl.getAttribute("data-action");

      switch (action) {
        case "toggle-panel":
          event.preventDefault();
          return this._togglePanel(actionEl);
        case "close-panel":
          event.preventDefault();
          return this.closePanel();
        case "save-search":
          event.preventDefault();
          // La feuille couvre l'écran : la refermer avant d'ouvrir le popover.
          // Sa cloche disparaît avec elle — pas d'ancre, le popover se pose en
          // bas d'écran (une cloche encore en transition le tirerait vers le vide).
          if (this._openSheetEl) {
            this.closeSheet();
            UI.triggerSaveSearch(null);
            return;
          }
          UI.triggerSaveSearch(actionEl);
          return;
        case "open-sheet":
          event.preventDefault();
          return this.openSheet(actionEl.getAttribute("data-sheet-target"));
        case "close-sheet":
          event.preventDefault();
          return this.closeSheet();
        case "open-drilldown":
          event.preventDefault();
          return this.openDrilldown(actionEl.getAttribute("aria-controls"));
        case "panel-back":
          event.preventDefault();
          return this.closeDrilldown();
        case "cat-back":
          event.preventDefault();
          if (this._catPath.length) {
            var popped = this._catPath.pop();
            api().setFilter(popped.key, []);
            return this._renderCategories(api().getState(), api().getFacets());
          }
          return this._isMobile() ? this.closeDrilldown() : this.closePanel();
        case "panel-apply":
          event.preventDefault();
          return this._isMobile() ? this.closeDrilldown() : this.closePanel();
        case "panel-clear":
        case "panel-reset":
          event.preventDefault();
          return this._clearPanel(actionEl.closest("[data-panel]"));
        case "clear-filters":
          event.preventDefault();
          this._catPath = [];
          return api().clear();
        case "remove-chip":
          event.preventDefault();
          return this._removeChip(actionEl);
        case "toggle-more":
          event.preventDefault();
          return this._toggleMore(actionEl);
        case "mataille-toggle":
          event.preventDefault();
          return this._toggleMataille();
        case "mataille-save":
          event.preventDefault();
          return this._saveMataille();
        case "mataille-signup":
          event.preventDefault();
          return UI.signupWithSizes(actionEl, this._selectedSizes());
      }
    }

    _removeChip(el) {
      var key = el.getAttribute("data-chip-key");
      if (key === "prix") return api().setPrice(null, null);
      return api().toggleFilter(key, el.getAttribute("data-chip-value"));
    }

    _clearPanel(panel) {
      if (!panel) return;
      var id = panel.id || "";
      if (id === "facet-panel-categories") { this._catPath = []; return CAT_LEVELS.forEach(function (k) { api().clear(k); }); }
      if (id === "facet-panel-mataille") { api().clear("taille"); return api().clear("pointure"); }
      if (id === "facet-panel-prix") return api().setPrice(null, null);
      var key = id.replace("facet-panel-", "");
      if (key) api().clear(key);
    }

    _toggleMore(btn) { UI.toggleMore(this, btn); }

    /* ── Panneaux, feuille, drill-down ──
       Mécanique commune aux deux barres : elle vit dans `assets/jaiio-facets-ui.js`,
       l'état reste ici (`_openPanelId`, `_openSheetEl`, `_drilldownId`…). */

    _togglePanel(trigger) { UI.togglePanel(this, trigger); }
    openPanel(panelId, trigger, focusMode) { UI.openPanel(this, panelId, trigger, focusMode); }
    closePanel() { UI.closePanel(this); }
    openSheet(targetSel) { UI.openSheet(this, targetSel); }
    closeSheet() { UI.closeSheet(this); }
    openDrilldown(panelId) { UI.openDrilldown(this, panelId); }
    closeDrilldown() { UI.closeDrilldown(this); }
  }

  if (!window.customElements.get("facet-bar-engine")) {
    window.customElements.define("facet-bar-engine", FacetBarEngine);
  }
})();
